import { createSelector } from '@ngrx/store';

import { getStakedTypes } from '../betplacement/services/stake/linear-stake-utils';
import { selectRewardTokens } from '../reward-tokens/selectors';
import { singleBetPicksGeneralStakeSelector } from '../single-bet/selectors';
import { GetSummaryStake } from '../stake/utils';
import { betslipTypeStateSelector, selectIsSingleBetSelected } from '../types/selectors';
import { selectCurrentStakeError } from '../validation/selectors';

export const selectSummaryStake = createSelector(betslipTypeStateSelector, (types) => GetSummaryStake(types));

export const selectCurrentStake = createSelector(
    selectSummaryStake,
    selectIsSingleBetSelected,
    singleBetPicksGeneralStakeSelector,
    (summaryStake, isSingleBet, singleBetStake) => (isSingleBet ? (singleBetStake?.actualStake ?? null) : summaryStake),
);

export const selectStakeValidationState = createSelector(selectCurrentStake, selectCurrentStakeError, (stake, stakeError) => ({
    stake,
    stakeError,
}));

export const selectStakedBetslipTypes = createSelector(betslipTypeStateSelector, selectRewardTokens, (types, tokens) =>
    getStakedTypes(types, tokens),
);
